import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import '@/plugins/highlight';
import '@/plugins/resize';
import '@/plugins/polyfills';
import pluralize from 'pluralize';
import Api from "@/api";
import Router from 'vue-router';
import App from './App.vue';
import Index from './pages/Index.vue';
import Docs from './pages/Docs.vue';
import Pricing from './pages/Pricing.vue';
import Cloud from './pages/Cloud.vue';
import Features from './pages/Overview.vue';
import Kubernetes from './pages/Kubernetes.vue';
import Solutions from "@/pages/Solutions.vue";
import Terms from './pages/legal/Terms.vue'
import Privacy from './pages/legal/Privacy.vue'
import * as validators from '@/utils/validation';
import events from '@/utils/events';
import Signup from "@/pages/auth/Signup.vue";
import Login from "@/pages/auth/Login.vue";
import Logout from "@/pages/auth/Logout.vue";
import AuthGoogle from "@/pages/auth/Google.vue";
import AuthSaml from "@/pages/auth/Saml.vue";
import ResetPasswordForm from "@/pages/auth/ResetPassword.vue";
import ActivateAccount from "@/pages/email/ActivateAccount.vue";
import ResetPassword from "@/pages/email/ResetPassword.vue";
import AcceptInvitation from "@/pages/email/AcceptInvitation.vue";
import Account from "@/pages/Account.vue";
import Console from "@/pages/console/Index.vue";
import Settings from "@/pages/console/Settings.vue";
import Workspace from "@/pages/console/Workspace.vue";
import WorkspaceSettings from "@/pages/console/WorkspaceSettings.vue";
import Project from "@/pages/console/Project.vue";
import Overview from "@/pages/console/Overview.vue";
import Node from "@/pages/console/Node.vue";
import Application from "@/pages/console/Application.vue";
import Workspaces from "@/pages/console/Workspaces.vue";
import St from "@/st";
import Blog from "@/pages/Blog.vue";

import Utils from '@coroot/coroot/src/utils/utils';
import * as Format from '@coroot/coroot/src/utils/format';
import * as storage from "@coroot/coroot/src/utils/storage";

Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.use(Router);

Vue.prototype.$coroot = {
    DemoWorkspaceId: window.Coroot.DemoWorkspaceId,
    appIdToStr(id) {
        return `${id.Namespace}:${id.Kind}:${id.Name}`;
    },
    appIdFromStr(id) {
        const parts = id.split(':');
        return {
            ns: parts[0] !== '_' ? parts[0] : '',
            kind: parts[1],
            name: parts[3] ? ':'+parts[3] : parts[2],
        }
    },
};

const router = new Router({
    mode: 'history',
    routes: [
        // { path: '/overview', name: 'features', component: Features, meta: {title: 'Overview'} },
        // { path: '/cloud', name: 'cloud', component: Cloud, meta: {title: 'Coroot Cloud'} },

        { path: '/docs/:chapter?/:group?/:item?', name: 'docs', component: Docs, props: true, meta: {title: 'Docs', fullWidth: true} },

        // {path: '/auth/signup', name: 'signup', component: Signup, meta: {title: 'Sign up'}},
        // {path: '/auth/login', name: 'login', component: Login, meta: {title: 'Login'}},
        {path: '/auth/logout', name: 'logout', component: Logout, meta: {title: 'Logout'}},
        {path: '/auth/reset', name: 'auth/reset', component: ResetPasswordForm, props: true, meta: {title: 'Reset Password'}},
        {path: '/auth/google', name: 'auth/google', component: AuthGoogle, props: true, meta: {}},
        // {path: '/auth/saml/:workspaceId', name: 'auth/saml', component: AuthSaml, props: true, meta: {}},

        {path: '/email/activate_account', component: ActivateAccount, meta: {}},
        {path: '/email/reset_password', component: ResetPassword, meta: {}},
        // {path: '/email/accept_invitation', component: AcceptInvitation, meta: {}},

        {path: '/console/settings', name: 'settings', component: Settings, props: true, meta: {title: 'Settings', auth: true}},
        {path: '/console/workspaces', name: 'workspaces', component: Workspaces, props: true, meta: {title: 'Console', auth: true}},
        {
            path: '/console/w/:workspaceId', name: 'workspace', component: Workspace, props: true,
            children: [
                {path: 'settings/:tab?', name: 'workspace_settings', component: WorkspaceSettings, props: true},
                {path: 'p/:projectId', name: 'project', component: Project, props: true,
                    children: [
                        {path: 'overview/:view?', name: 'overview', component: Overview, props: true},
                        {path: 'nodes/:name', name: 'node', component: Node, props: true},
                        {path: 'app/:id/:report?', name: 'application', component: Application, props: true},
                    ],
                },
            ],
            meta: {title: 'Console', auth: true, fullWidth: true},
        },
        {path: '/console', name: 'console', component: Console, meta: {title: 'Console', auth: true}},

        {path: '/account', name: 'account', component: Account, props: true, meta: {title: 'Account | Coroot Customer Portal'}},
        {path: '/account/signup', name: 'signup', component: Account, props: {page: 'signup'}, meta: {title: 'Create your account in Coroot Customer Portal | Sign Up for Free Today'}},
        {path: '/account/signin', name: 'signin', component: Account, props: {page: 'signin'}, meta: {title: 'Sign in into Coroot Customer Portal | Manage your Coroot Enterprise licenses'}},

        { path: '*', redirect: {name: 'account'}},
    ],
    scrollBehavior(to, from, savedPosition) {
        // if (savedPosition) {
        //     return new Promise((resolve) => {
        //         setTimeout(() => {
        //             resolve(savedPosition);
        //         }, 300);
        //     });
        // }
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    try {
                        const e = document.querySelector(to.hash);
                        if (e) {
                            const rect = e.getBoundingClientRect();
                            const visible = rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0;
                            if (visible) {
                                resolve({});
                                return;
                            }
                        }
                        resolve({selector: to.hash, offset: {x: 0, y: 200}});
                    } catch {
                        resolve({});
                    }
                }, 300);
            });
        }
        return {x: 0, y: 0};
    },
});

const api = new Api(router);
Vue.prototype.$api = api;
const st = new St(vuetify, router, api);
Vue.prototype.$st = st;
Vue.prototype.$events = events;
Vue.prototype.$utils = new Utils(router);
Vue.prototype.$format = Format;
Vue.prototype.$validators = validators;
Vue.prototype.$pluralize = pluralize;
Vue.prototype.$storage = storage;

// router.beforeEach((to, from, next) => {
//     if (!to.matched.some((record) => record.meta.auth)) {
//         next();
//         return;
//     }
//     api.checkToken((anonymous) => {
//         if (!anonymous) {
//             if (to.params.workspaceId) {
//                 api.checkWorkspaceApi(to.params.workspaceId, next);
//                 return;
//             }
//             next();
//             return;
//         }
//         const login = {name: 'login', query: to.name !== 'index' ? {next: to.fullPath} : {}};
//         if (!to.params.workspaceId) {
//             next(login);
//             return;
//         }
//         api.getWorkspaceAuthMethod(to.params.workspaceId, auth => {
//             if (auth === 'saml') {
//                 next({name: 'auth/saml', params: {workspaceId: to.params.workspaceId}});
//                 return;
//             }
//             next(login);
//         });
//     });
// });

router.afterEach((to, from) => {
    if (to.query.from !== from.query.from || to.query.to !== to.query.to) {
        events.emit('refresh', null);
    }
    if (to.params.projectId !== from.params.projectId) {
        events.emit('refresh', null);
        api.setLastProject(to.params.projectId);
    }
    let t = '';
    to.matched.some((record) => {
        if (record.meta.title) {
            t = record.meta.title;
            return true;
        }
    })
    if (t) {
        document.title = t;
    }

    st.send('route-open', {from: from.fullPath});
});

window.onbeforeunload = () => {
    st.send('window-unload', null);
};

document.onvisibilitychange = () => {
    st.send('document-visibility-' + document.visibilityState, null);
}

import CodeSnippet from "@/components/CodeSnippet.vue";
import ImageWrapper from "@/components/ImageWrapper.vue";

Vue.component("CodeSnippet", CodeSnippet);
Vue.component("ImageWrapper", ImageWrapper);

new Vue({
    vuetify,
    router,
    render: (h) => h(App),
}).$mount('#app');
